module.exports = __webpack_public_path__ + "img/logo2.0f46d665.png";